import { ResourceTypeId } from '~/client/src/shared/constants/resourceTypes'

import { ResourceSemanticIconKey } from '../definitions/types'

const RESOURCE_TYPE_ICON_KEYS: Partial<
  Record<ResourceTypeId, ResourceSemanticIconKey>
> = {
  [ResourceTypeId.OFFLOADING_EQUIPMENT]: 'equipment',
  [ResourceTypeId.MATERIALS]: 'material',
  [ResourceTypeId.SENSORS]: 'sensor',
}

export function getResourceIconKey(
  resourceTypeId: string,
): ResourceSemanticIconKey | undefined {
  return RESOURCE_TYPE_ICON_KEYS[resourceTypeId as ResourceTypeId]
}
